(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/keno-xpress/assets/react/components/betslip.js') >= 0) return;  svs.modules.push('/modules/keno-xpress/assets/react/components/betslip.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState;
const Payfooter = svs.tur.ReactPayfooter.Payfooter;
const Betslip = _ref => {
  let hasKungKeno = _ref.hasKungKeno,
    selectedPrice = _ref.selectedPrice,
    isVisible = _ref.isVisible,
    handleDemoGame = _ref.handleDemoGame,
    handlePayGame = _ref.handlePayGame,
    isAlreadyPayed = _ref.isAlreadyPayed;
  const _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    playerBalance = _useState2[0],
    setPlayerBalance = _useState2[1];
  useEffect(() => {
    svs.components.account_balance.get(true, balance => {
      setPlayerBalance(balance);
    });
  }, []);
  return React.createElement(Payfooter, {
    balance: playerBalance,
    buttons: [isAlreadyPayed ? {
      onClick: handlePayGame,
      primary: true,
      disabled: !isVisible,
      text: 'Fortsätt'
    } : {
      onClick: handlePayGame,
      pay: true,
      disabled: !isVisible
    }, {
      onClick: handleDemoGame,
      secondary: true,
      text: 'Provspela',
      disabled: !isVisible
    }, {
      className: 'js-pause24-trigger',
      link: true,
      text: 'SPELPAUS24'
    }],
    isBottom: true,
    sum: isVisible ? selectedPrice * (hasKungKeno + 1) : 0
  });
};
setGlobal('svs.kenoXpress.react.components.Betslip', Betslip);

 })(window);